module.exports = __webpack_public_path__ + "img/walls_foundation_.e2675d35.svg";